import { SearchUpliftContractLinesQuery } from '@/graphql/contracts/_generated_/SearchUpliftContractLines.query';
import { UpliftData_Updated_Contractline } from './useCalculateContractLineUplift';
import { Action } from '../components/ContractLinesGrid';


type contractLine = NonNullable<SearchUpliftContractLinesQuery['contractLinesByUpliftFilterByBillingCycles'][number]>;

export interface UpliftData_contractLine extends contractLine {
  upliftValue?: number | null;
  billingType?: string;
  newBillingPeriodValue?: string | null,
  newAnnualBillingPeriodValue?: string;
  originalNextUpliftDate?: Date | null;
  newPricePerUnit?: string;
  action?: Action;
}

export default function useConvertUpliftDataFormat(
  data: (contractLine | null)[],
  upliftedLines: (UpliftData_Updated_Contractline[] | null),
) {

  const convertedData = (): (UpliftData_contractLine | null)[] => {
    const upliftData: (UpliftData_contractLine | null)[] = [];
    data?.map((d) => {

      const item: UpliftData_contractLine = {
        __typename: d?.__typename!,
        annualBillingPeriodValue: d?.annualBillingPeriodValue!,
        billingInterval: d?.billingInterval!,
        contractID: d?.contractID!,
        billingPeriodValue: d?.billingPeriodValue!,
        contractLineID: d?.contractLineID!,
        contractNumber: d?.contractNumber!,
        quantity: d?.quantity!,
        status: d?.status!,
        pricePerUnit: d?.pricePerUnit!,
        unitPriceFrequency: d?.unitPriceFrequency!,
        product: d?.product!,
        contractStartDate: d?.contractStartDate!,
        renewableTerm: d?.renewableTerm!,
        daysBeforeRenewal: d?.daysBeforeRenewal,
        pONumber: d?.pONumber,
        poEndDate: d?.poEndDate,
        poRemainingValue: d?.poRemainingValue,
        nextUpliftDate: d?.nextUpliftDate,
        originalNextUpliftDate: d?.nextUpliftDate,
      };
      if (upliftedLines && upliftedLines.length > 0) {
        const found = upliftedLines.find(x => x.contractLineID == item.contractLineID);
        const clearEditableCells = () => {
          item.upliftValue = undefined;
          item.billingType = undefined;
          item.newBillingPeriodValue = undefined;
          item.newAnnualBillingPeriodValue = undefined;
          item.newPricePerUnit = undefined;
        };
        if (found && found.action === Action.APPLY) {
          item.pricePerUnit = found.pricePerUnit!;
          item.annualBillingPeriodValue = found.annualBillingPeriodValue!;
          item.billingPeriodValue = found.billingPeriodValue;
          item.nextUpliftDate = found.nextUpliftDate;
          clearEditableCells();

        } else if (found && found.action === Action.CANCEL) {
          clearEditableCells();
        } else {
          item.upliftValue = found?.upliftValue;
          item.billingType = found?.billingType;
          item.newBillingPeriodValue = found?.newBillingPeriodValue;
          item.newAnnualBillingPeriodValue = found?.newAnnualBillingPeriodValue!;
          item.nextUpliftDate = found?.nextUpliftDate ?? item?.nextUpliftDate;
          item.newPricePerUnit = found?.pricePerUnit;
        }
      }

      return upliftData.push(item);
    });

    return upliftData;
  };

  return {
    data: convertedData(),
  } as const;
}
